/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * BankAccounts. List of bank accounts.
 */
export interface BankAccountResult { 
    /**
     * IBAN of the bank account.
     */
    iban?: string;
    /**
     * SWIFT of the bank account.
     */
    swift?: string;
    /**
     * List of Holders of the bank account with slash separator.
     */
    holders?: string;
    /**
     * Address of the bank account.
     */
    accountAddress?: string;
    /**
     * Currency type of the bank account. Format ISO 4217, Example: Euro = EUR. Maximum lenght 3
     */
    currencyType?: string;
    /**
     * Name of the bank account.
     */
    bankName?: string;
}

